// src/components/layout/Header/NavigationalLayer/NavigationalLayer.jsx

'use client'

import { useState } from 'react';
import { usePathname } from 'next/navigation';
import Link from 'next/link'
import { Menu as MenuIcon } from '@mui/icons-material';
import { Drawer } from '@mui/material';
import { cartIcon } from '@/containers/Icons';
import CartCounter from '@/components/layout/Header/NavigationalLayer/CartCounter';  // v0 confirmed import type
import styles from '../Header.module.scss';


const tempHidden = ['services', 'shopBeds', 'shopShoes', 'shopGloves'];


export default function NavigationalLayer({ lang, navDict, isDev }) {

  const [drawerOpen, setDrawerOpen] = useState(false);
  const pathname = usePathname();

  const navItemsList = Object.keys(navDict)
    .filter(itemName => isDev || !tempHidden.includes(itemName))
    .map(itemName => {
      const isCurrent = (itemName === 'home' && pathname.endsWith(`/${lang}`)) || pathname.endsWith(`/${lang}${navDict[itemName].route}`);
      return (
        <li key={itemName}>
          <Link
            href={`/${lang}${navDict[itemName].route}`}
            style={isCurrent ? {fontWeight: 'bold'} : {}}
            aria-current={isCurrent ? 'page' : undefined}
            aria-label={navDict[itemName].ariaLabel}
            prefetch={itemName === 'shopCarpets' ? true : null}
          >
            {navDict[itemName].title}
          </Link>
        </li>
      )
    });

  // Function to toggle the drawer
  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  return (
    <nav aria-label={'Main Navigation'} className={styles.headerNav}>

      {/* MUI Drawer component */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        aria-label="Mobile navigation menu"
      >
        <ul style={{width: 250}} onClick={toggleDrawer(false)} onKeyDown={toggleDrawer(false)} className={styles.drawerList} role="menu" aria-label="Navigation options">
          {navItemsList}
        </ul>
      </Drawer>

      {/* Hamburger menu icon to open the drawer */}
      <button onClick={toggleDrawer(true)} aria-expanded={drawerOpen ? 'true' : 'false'} aria-haspopup="true" aria-label="Open main navigation menu"><MenuIcon aria-hidden="true"/> All</button>

      {/* Regular navigation for larger screens */}
      <ul aria-label="Main navigation">{navItemsList}</ul>

      <Link href={`/${lang}/cart`} aria-label={'Link to Shopping Cart'} className={styles.cartLink}>
        {cartIcon}<CartCounter/>
      </Link>
    </nav>
  )
}
